/** Windows-style minimize / medium / maximize buttons for cards */

interface WinButtonsProps {
  current: 'min' | 'med' | 'max'
  onMin?: () => void
  onMed?: () => void
  onMax?: () => void
}

export function WinButtons({ current, onMin, onMed, onMax }: WinButtonsProps) {
  return (
    <span className="card__winbtns">
      <button
        className="card__winbtn"
        onClick={onMin}
        title="Minimera"
        style={current === 'min' ? { background: 'rgba(255,255,255,0.1)' } : undefined}
      >
        &#9143;
      </button>
      <button
        className="card__winbtn"
        onClick={onMed}
        title="Medium"
        style={current === 'med' ? { background: 'rgba(255,255,255,0.1)' } : undefined}
      >
        &#9645;
      </button>
      <button
        className="card__winbtn"
        onClick={onMax}
        title="Maximera"
        style={current === 'max' ? { background: 'rgba(255,255,255,0.1)' } : undefined}
      >
        &#9744;
      </button>
    </span>
  )
}

export interface CardSizeProps {
  collapsed?: boolean
  medium?: boolean
  onMin?: () => void
  onMed?: () => void
  onMax?: () => void
}

export function currentSize(props: CardSizeProps): 'min' | 'med' | 'max' {
  if (props.collapsed) return 'min'
  if (props.medium) return 'med'
  return 'max'
}
